module.exports = "/static/assets/9c2e8fc66ddf257858ee277af88a7e45.png";